export default {
  tabs: {
    balanceSheet: 'Balance Sheet',
    incomeStatement: 'Income Statement',
    cashFlowStatement: 'Cash Flow Statement',
  },
  timeTab: {
    quarterly: 'Quarterly',
    yearly: 'Yearly',
  },
  quarterName: 'Q%{quarter} %{year}',
  yearName: '%{year}',
  noHeadTitle: '--',

  item: 'ITEMS',
  trend: 'TREND',

  currentAssetsTooltip: 'Current Assets: %{tooltipValue} (%{percent}%)',
  tangibleFixedAssetsTooltip: 'Tangible Assets: %{tooltipValue} (%{percent}%)',
  intangibleFixedAssetsTooltip:
    'Intangible fixed Assets: %{tooltipValue} (%{percent}%)',
  intagibleFixedAssetsTooltip:
    'Intangible fixed Assets: %{tooltipValue} (%{percent}%)',
  otherAssetsTooltip: 'Other Assets: %{tooltipValue} (%{percent}%)',

  currentLiabilitiesTooltip:
    'Current Liabilities: %{tooltipValue} (%{percent}%)',
  longTermLiabilitiesTooltip:
    'Long-term Liabilities: %{tooltipValue} (%{percent}%)',
  longtermLiabilitesTooltip:
    'Long-term Liabilities: %{tooltipValue} (%{percent}%)',
  shareholdersEquityTooltip:
    'Shareholder Equity: %{tooltipValue} (%{percent}%)',
  shareholderEquityTooltip: 'Shareholder Equity: %{tooltipValue} (%{percent}%)',
  minorityInterestTooltip: 'Minority interest: %{tooltipValue} (%{percent}%)',
  minorityInterestBeforeTooltip:
    'Minority interest: %{tooltipValue} (%{percent}%)',

  placementsLoanToCreditInstitutionsTooltip:
    'Placements & loan to credit institutions: %{tooltipValue} (%{percent}%)',
  loansAdvancesToCustomersTooltip:
    'Loans & advances to customers: %{tooltipValue} (%{percent}%)',
  loansAndAdvancesToCustomersOneTooltip:
    'Loans & advances to customers: %{tooltipValue} (%{percent}%)',
  investmentSecuritiesTooltip:
    'Investment Securities: %{tooltipValue} (%{percent}%)',

  depositsFromCustomersTooltip:
    'Deposits from customers: %{tooltipValue} (%{percent}%)',
  otherLiabilitiesTooltip: 'Other Liabilities: %{tooltipValue} (%{percent}%)',
  otherLiabilitesTooltip: 'Other Liabilities: %{tooltipValue} (%{percent}%)',
  shareholdersEquity: "Shareholders' Equity: %{tooltipValue} (%{percent}%)",

  totalAssets: 'TOTAL ASSETS',
  currentAssets: 'CURRENT ASSETS',

  cashAndCashEquivalents: 'Cash and cash equivalents',
  cash: 'Cash',
  cashEquivalents: 'Cash equivalents',

  shortTermInvestment: 'Short-term investments',
  shortTermInvestmentChild: 'Short-term investments',
  provisionForDiminution: 'Provision for diminution',
  heldToMaturityInvestment: 'Held-to-maturity investment',

  accountReceivable: 'Accounts receivable',
  tradeAccountReceivable: 'Trade accounts receivable',
  prepaymentsToSuppliers: 'Prepayments to suppliers',
  interCompanyReceivables: 'Intercompany receivables',
  constructionContractInProgressReceivables:
    'Construction contract in progress receivables',
  shortTermLoansReceivables: 'Short-term loans receivables',
  otherReceivables: 'Other receivables',
  provisionForDoubtfulDebts: 'Provision for doubtful debts',
  shortageOfCurrentAssetsWaitingForSolution:
    'Shortage of current assets waiting for solution',

  inventories: 'Inventories',
  inventoriesChild: 'Inventories',
  provisionForDeclineInInventories: 'Provision for decline in inventories',

  otherCurrentAssets: 'Other current assets',
  shortTermPrepaidExpenses: 'Short-term prepaid expenses',
  VATToBeClaimed: 'VAT to be claimed',
  otherTaxesReceivable: 'Other taxes receivable',
  governmentBondsPurchasedForResale: 'Government bonds purchased for resale',
  otherCurrentAssetsChild: 'Other current assets',

  longTermAssets: 'LONG-TERM ASSETS',

  longTermTradeReceivables: 'Long-term trade receivables',
  longTermTradeReceivablesFromCustomers:
    'Long-term trade receivables from customers',
  longTermPrepaymentsToSuppliers: 'Long-term prepayments to suppliers',
  paidInCapitalInWhollyOwnedSubsidiaries:
    'Paid-in capital in wholly-owned subsidiaries',
  longTermInterCompanyReceivables: 'Long-term intercompany receivables',
  longTermLoansReceivables: 'Long-term loans receivables',
  otherLongTermReceivables: 'Other long-term receivables',
  provisionForDoubtfulLTReceivable: 'Provision for doubtful LT receivable',

  fixedAssets: 'Fixed assets',
  tangibleFixedAssets: 'Tangible fixed assets',
  tangibleFixedAssetsCost: 'Cost',
  tangibleFixedAssetsAccumulatedDepreciation: 'Accumulated depreciation',
  financeLeaseAssets: 'Finance lease assets',
  financeLeaseAssetsCost: 'Cost',
  financeLeaseAssetsAccumulatedDepreciation: 'Accumulated depreciation',
  intangibleFixedAssets: 'Intangible fixed assets',
  intangibleFixedAssetsCost: 'Cost',
  intangibleFixedAssetsAccumulatedDepreciation: 'Accumulated depreciation',

  investmentProperties: 'Investment properties',
  investmentPropertiesCost: 'Cost',
  investmentPropertiesAccumulatedDepreciation: 'Accumulated depreciation',

  longTermIncompleteAssets: 'Long-term incomplete assets',
  longTermCostOfWorkInProgress: 'Long-term cost of work in progress',
  constructionInProgress: 'Construction in progress',

  longTermInvestments: 'Long-term investments',
  investmentsInSubsidiaries: 'Investments in subsidiaries',
  investmentsInAssociates: 'Investments in associates',
  otherLongTermInvestments: 'Other long-term investments',
  provisionForLongTermInvestments: 'Provision for long-term investments',
  longTermInvestmentsHeldToMaturityInvestment: 'Held-to-maturity investment',

  otherLongTermAssets: 'Other long-term assets',
  longTermPrepayments: 'Long-term prepayments',
  deferredIncomeTaxAssets: 'Deferred income tax assets',
  longTermEquipmentAndMaterialAndSpareParts:
    'Long-term equipment, material and spare parts',
  otherLongTermAssetsChild: 'Other long-term assets',
  goodWill: 'Good will',

  liabilities: 'LIABILITIES',

  currentLiabilities: 'Current liabilities',
  tradeAccountsPayable: 'Trade accounts payable',
  advancesFromCustomers: 'Advances from customers',
  taxesAndOtherPayableToStateBudget: 'Taxes and other payable to State Budget',
  payableToEmployees: 'Payable to employees',
  accruedExpenses: 'Accrued expenses',
  interCompanyPayable: 'Intercompany payables',
  constructionContractInProgressPayable:
    'Construction contract in progress payables',
  shortTermUnrealizedRevenue: 'Short-term unrealized revenue',
  otherPayable: 'Other payables',
  shortTermBorrowings: 'Short-term borrowings',
  provisionForSTLiabilities: 'Provision for ST liabilities',
  bonusAndWelfareFunds: 'Bonus and welfare funds',
  priceStabilizationFund: 'Price stabilization fund',
  currentLiabilitiesGovernmentBondsPurchasedForResale:
    'Government bonds purchased for resale',

  longTermLiabilities: 'Long-term liabilities',
  longTermTradePayable: 'Long-term trade payables',
  longTermAdvancesFromCustomers: 'Long-term advances from customers',
  longTermAccruedExpenses: 'Long-term accrued expenses',
  intraCompanyPayablesForOperatingCapitalReceived:
    'Intra-company payables for operating capital received',
  longTermInterCompanyPayable: 'Long-term intercompany payables',
  unrealizedRevenue: 'Unrealized revenue',
  otherLongTermPayable: 'Other long-term payables',
  longTermBorrowings: 'Long-term borrowings',
  convertibleBonds: 'Convertible bonds',
  longTermLiabilitiesPreferredShares: 'Preferred shares',
  preferredShares: 'Preferred shares',
  deferredIncomeTaxLiabilities: 'Deferred income tax liabilities',
  provisionForSeveranceAllowances: 'Provision for severance allowances',
  provisionForLongTermLiabilities: 'Provision for long-term liabilities',
  technologyScienceDevelopmentFund: 'Technology-science development fund',

  ownerEquity: "OWNER'S EQUITY",

  capitalAndReserves: 'Capital and reserves',
  paidInCapital: 'Paid-in capital',
  commonShares: 'Common shares',
  sharePremium: 'Share premium',
  conversionOptionsOnConvertibleBonds:
    'Conversion options on convertible bonds',
  ownerOtherCapital: "Owner's other capital",
  treasuryShares: 'Treasury shares',
  differencesUponAssetRevaluation: 'Differences upon asset revaluation',
  foreignExchangeDifferences: 'Foreign exchange differences',
  investmentAndDevelopmentFunds: 'Investment and development funds',
  enterpriseArrangementFund: 'Enterprise arrangement fund',
  financialReserveFunds: 'Financial researve funds',
  otherFunds: 'Other funds',
  undistributedEarnings: 'Undistributed earnings',
  beginningAccumulatedUndistributedEarnings:
    'Beginning accumulated undistributed earnings',
  currentPeriodUndistributedEarnings: 'Current period undistributed earnings',
  capitalAndReservesMinorityInterests: 'Minority interests',

  budgetSourcesAndFunds: 'Budget sources and other funds',

  bonusAndWelfareFundsBefore2010: 'Bonus and welfare funds (Before 2010)',
  budgetSourcesAndOtherFundsBefore2010: 'Budget sources and other funds',
  fundsUsedForFixedAssetAcquisitions: 'Funds used for fixed asset acquisitions',

  minorityInterest: 'MINORITY INTERESTS',

  totalResources: 'TOTAL RESOURCES',

  sales: 'Sales',
  salesDeductions: 'Sales deductions',
  netSales: 'Net sales',
  costOfSales: 'Cost of sales',
  grossProfit: 'Gross Profit',
  financialIncome: 'Financial income',
  financialExpenses: 'Financial expenses',
  ofWhichInterestExpenses: 'of which: interest expenses',
  GainLossFromJointVenturesFrom2015:
    'Gain/(loss) from joint ventures (from 2015)',
  sellingExpenses: 'Selling expenses',
  generalAndAdminExpenses: 'General and admin expenses',

  operatingProfitLoss: 'Operating profit/(loss)',
  otherIncomes: 'Other incomes',
  otherExpenses: 'Other expenses',

  netOtherIncomeExpenses: 'Net other income/(expenses)',
  incomeFromInvestmentsInOtherEntities:
    'Income from investments in other entities',

  netAccountingProfitLossBeforeTax: 'Net accounting profit/(loss) before tax',
  corporateIncomeTaxCurrent: 'Corporate income tax - current',
  corporateIncomeTaxDeferred: 'Corporate income tax - deferred',

  corporateIncomeTaxExpenses: 'Corporate income tax expenses',
  netProfitLossAfterTax: 'Net profit/(loss) after tax',
  minorityInterests: 'Minority interests',
  attributableToParentCompany: 'Attributable to parent company',
  EPSBasis: 'EPS (VND)',
  EPSDiluted: 'EPS Diluted (VND)',

  cashAndPreciousMetals: 'Cash and precious metals',
  balancesWithTheSBV: 'Balances with the SBV',
  placementsWithAndLoansToOtherCreditInstitutions:
    'Placements with and loans to other credit institutions',

  tradingSecuritiesNet: 'Trading securities, net',
  tradingSecurities: 'Trading securities',
  lessProvisionForDiminutionInValueOfTradingSecurities:
    'Less: Provision for diminution in value of trading securities',

  derivativesAndOtherFinancialAssets: 'Derivatives and other financial assets',
  loansAndAdvancesToCustomersNet: 'Loans and advances to customers, net',
  loansAndAdvancesToCustomersOne: 'LOANS AND ADVANCES TO CUSTOMERS',
  loansAndAdvancesToCustomers: 'Loans and advances to customers',
  lessProvisionForLossesOnLoansAndAdvancesToCustomers:
    'Less: Provision for losses on loans and advances to customers',

  investmentSecurities: 'Investment securities',
  availableForSalesSecurities: 'Available-for-sales securities',
  heldToMaturitySecurities: 'Held-to-maturity securities',
  lessProvisionForDiminutionInValueOfInvestmentSecurities:
    'Less: Provision for diminution in value of investment securities',

  investmentInOtherEntitiesAndLongTermInvestments:
    'Investment in other entities and long term investments',
  investmentInJointVentures: 'Investment in Joint Ventures',
  investmentInAssociateCompanies: 'Investment in associate companies',
  financeLeasedAssets: 'Finance leased assets',

  otherAssets: 'Other assets',

  liabilitiesAndShareholderEquity: "LIABILITIES AND SHAREHOLDER'S EQUITY",

  totalLiabilities: 'Total liabilities',
  dueToGovAndBorrowingsFromSBV: 'Due to Gov and borrowings from SBV',
  depositsAndBorrowingsFromOtherCreditInstitutions:
    'Deposits and borrowings from other credit institutions',
  depositsFromCustomers: 'Deposits from customers',
  derivativesAndOtherFinancialLiabilities:
    'Derivatives and other financial liabilities',
  fundsReceivedFromGovInternationalAndOtherInstitutions:
    'Funds received from Gov, international and other institutions',
  convertibleBondsCDsAndOtherValuablePapersIssued:
    'Convertible bonds/CDs and other valuable papers issued',
  otherLiabilities: 'Other liabilities',

  shareholderEquity: "Shareholder's equity",
  capital: 'Capital',
  charterCapital: 'Charter capital',
  fundForBasicConstruction: 'Fund for basic construction',
  otherCapitals: 'Other capitals',
  reserves: 'Reserves',
  differenceUponAssetsRevaluation: 'Difference upon assets revaluation',
  foreignCurrencyDifferenceReserve: 'Foreign currency difference reserve',
  retainedEarnings: 'Retained Earnings',

  chartTitle: {
    currentAssets: 'Current Assets',
    tangibleFixedAssets: 'Tangible Fixed Assets',
    intangibleFixedAssets: 'Intangible Fixed Assets',
    otherAssets: 'Other Assets',
    currentLiabilities: 'Current Liabilities',
    longTermLiabilities: 'Long-term Liabilities',
    shareholdersEquity: 'Shareholders’ Equity',
    minorityInterest: 'Minority interest',
    minorityInterestBefore: 'MINORITY INTEREST (before 2015)',
    placementsLoanToCreditInstitutions:
      'Placements & loan to credit institutions',
    loansAdvancesToCustomers: 'Loans & advances to customers',
    investmentSecurities: 'Investment Securities',
    depositsFromCustomers: 'Deposits from customers',
    otherLiabilities: 'Other Liabilities',
  },

  incomeStatementChart: {
    revenue: 'Revenue',
    operatingProfit: 'Operating Profit',
    netProfit: 'Net Profit',
    netProfitMargin: 'Net Profit Margin (%)',
    profitAndLoss: 'Profit And Loss',

    revenueTooltip: 'Revenue: %{tooltipValue} Bn. VND',
    operatingProfitTooltip: 'Operating Profit: %{tooltipValue} Bn. VND',
    netProfitTooltip: 'Net Profit: %{tooltipValue} Bn. VND',
    netProfitMarginTooltip: 'Net Profit Margin (TTM): %{tooltipValue} %',
    netRevenueOfInsurancePremiumTooltip:
      'Net revenue of insurance premium: %{tooltipValue} Bn. VND',
    netOperatingProfitFromInsuranceOperationTooltip:
      'Net operating profit from insurance operation: %{tooltipValue} Bn. VND',

    netInterestIncome: 'Net Interest Income',
    netFeeAndCommissionIncome: 'Net Fee and Commission Income',
    operatingIncome: 'Operating Income',
    provisionForCreditLoses: 'Provision for credit loses',
    netProfitAfterTax: 'Net Profit After Tax',

    netInterestIncomeTooltip: 'Net Interest Income: %{tooltipValue} Bn. VND',
    netFeeAndCommissionIncomeTooltip:
      'Net Fee and Commission Income: %{tooltipValue} Bn. VND',
    operatingIncomeTooltip: 'Operating Income: %{tooltipValue} Bn. VND',
    provisionForCreditLosesTooltip:
      'Provision for credit loses: %{tooltipValue} Bn. VND',
    netProfitAfterTaxTooltip: 'Net Profit After Tax: %{tooltipValue} Bn. VND',
  },

  netCashInflowsFromOperatingActivities:
    'Net cash inflows/(outflows) from operating activities',
  operatingProfitLossBeforeChangesInWorkingCapital:
    '     Operating profit/(loss) before changes in Working Capital',
  netProfitBeforeTax: 'Net profit/(loss) before tax',
  depreciationAndAmortisation: 'Depreciation and amortisation',
  amortisationOfGoodwill: 'Amortisation of goodwill',
  provisions: 'Provisions',
  unrealisedForeignExchangeGainLoss: 'Unrealised foreign exchange gain/loss',
  profitLossFromLiquidatingFixedAssets:
    'Profit/loss from liquidating fixed assets',
  profitLossFromInvestingActivities: 'Profit/loss from investing activities',
  interestExpense: 'Interest expense',
  interestIncomeAndDividend: 'Interest income and dividend',
  otherAdjustments: 'Other adjustments',
  increaseDecreaseInReceivables: '(Increase)/decrease in receivables',
  increaseDecreaseInventories: '(Increase)/decrease in inventories',
  increaseDecreasePayable: '(Increase/(decrease) in payables',
  increaseDecreasePrepaidExpenses: '(Increase)/decrease in prepaid expenses',
  increaseDecreaseTradingSecurities:
    '(Increase)/decrease in trading securities',
  interestPaid: 'Interest paid',
  corporateIncomeTaxPaid: 'Corporate Income Tax paid',
  otherReceiptsFromOperatingActivities:
    'Other receipts from operating activities',
  otherPaymentsOnOperatingActivities: 'Other payments on operating activities',

  netCashInflowsOutflowsFromInvestingActivities:
    'Net cash inflows/(outflows) from investing activities',
  purchasesOfFixedAssetsAndOtherLongTermAssets:
    'Purchases of fixed assets and other long term assets',
  proceedsFromDisposalOfFixedAssets: 'Proceeds from disposal of fixed assets',
  loansGrantedPurchasesOfDebtInstruments:
    'Loans granted, purchases of debt instruments',
  collectionOfLoansProceedsFromSalesOfDebtsInstruments:
    'Collection of loans, proceeds from sales of debts instruments',
  investmentsInOtherEntities: 'Investments in other entities',
  proceedsFromDivestmentInOtherEntities:
    'Proceeds from divestment in other entities',
  dividendsAndInterestReceived: 'Dividends and interest received',

  netCashInflowsOutflowsFromFinancingActivities:
    'Net cash inflows/(outflows) from financing activities',
  proceedsFromIssueOfShares: 'Proceeds from issue of shares',
  paymentsForShareReturnsAndRepurchases:
    'Payments for share returns and repurchases',
  proceedsFromBorrowings: 'Proceeds from borrowings',
  repaymentOfBorrowings: 'Repayment of borrowings',
  financeLeasePrincipalPayments: 'Finance lease principal payments',
  dividendsPaid: 'Dividends paid',
  interestsDividendsProfitsReceived: 'Interests, dividends, profits received',

  netIncreaseInCashAndCashEquivalents:
    'Net increase in cash and cash equivalents',
  cashAndCashEquivalentsAtTheBeginningOPeriod:
    'Cash and cash equivalents at the beginning o period',
  effectOfForeignExchangeDifferences: 'Effect of foreign exchange differences',
  cashAndCashEquivalentsAtTheEndOfPeriod:
    'Cash and cash equivalents at the end of period',

  // banking
  netCashFromOperatingActivities: 'Net cash from operating activities',
  netCashFlowsFromOperatingActivitiesBeforeBIT:
    'Net cash flows from operating activities before BIT',
  interestAndSimilarReceipts: 'Interest and similar receipts',
  interestAndSimilarPayments: 'Interest and similar payments',
  feesAndCommissionIncomeReceived: 'Fees and commission income received',
  netReceiptsFromDealingOfForeignCurrenciesGold:
    'Net receipts  from dealing of foreign currencies, gold',
  netReceiptsFromDealingOfSecurities:
    'Net receipts  from dealing of securities',
  otherOperatingIncome: 'Other operating income',
  receiptsFromDebtsWrittenOffOrPaidOffByRiskFund:
    'Receipts from debts written off or paid off by risk fund',
  paymentsToEmployeesAndOtherOperatingExpenses:
    'Payments to employees and other operating expenses',
  paymentsForCorporateIncomeTax: 'Payments for corporate income tax',
  increaseDecreaseInCompulsoryReservesWithTheSBV:
    '(Increase)/decrease in compulsory reserves with the SBV',
  increaseDecreaseInPlacementsWithAndLoansToOtherCreditInstitutions:
    '(Increase)/decrease in placements with and loans to other credit institutions',
  increaseDecreaseInTradingSecurities:
    '(Increase)/decrease in trading securities',
  increaseDecreaseInDerivativesAndOtherFinancialAssets:
    '(Increase)/decrease in derivatives and other financial assets',
  increaseDecreaseInLoansAndAdvancesToCustomers:
    '(Increase)/decrease in loans and advances to customers',
  increaseDecreaseInInterestReceivable:
    '(Increase)/decrease in interest receivable',
  increaseDecreaseInProvisionForLoanLosses:
    '(Increase/(decrease) in provision for loan losses',
  increaseDecreaseInOtherOperatingAssets:
    '(Increase)/decrease in other operating assets',
  increaseDecreaseInBorrowingsFromTheStateAndSbv:
    'Increase/(decrease) in borrowings from the State and SBV',
  increaseDecreaseInPlacementsAndBorrowingsFromOtherCreditInstitutions:
    'Increase/(decrease) in placments and borrowings from other credit institutions',
  increaseDecreaseInDepositsFromCustomers:
    'Increase/(decrease) in deposits from customers',
  increaseDecreaseInDerivativesAndOtherFinancialLiabilities:
    'Increase/(decrease) in derivatives and other financial liabilities',
  increaseDecreaseInFundsReceivedFromGovInternationalAndOtherInstitutions:
    'Increase/(decrease) in funds received from Gov, international and other institutions',
  increaseDecreaseInValuablePapersIssued:
    'Increase/(decrease) in valuable papers issued',
  increaseDecreaseInAccruedInterestExpenses:
    'Increase/(decrease) in accrued interest expenses',
  increaseDecreaseInOtherOperatingLiabilities:
    'Increase/(decrease) in other operating liabilities',
  paymentFromReserves: 'Payment from reserves',
  badDebtRecoveries: 'Bad debt recoveries',

  netCashFromInvestingActivities: 'Net cash from investing activities',
  paymentsOnDisposalOfFixedAssets: 'Payments on disposal of fixed assets',
  purchasesOfInvestmentProperties: 'Purchases of investment properties',
  proceedsFromDisposalOfInvestmentProperties:
    'Proceeds from disposal of investment properties',
  paymentsOnDisposalOfInvestmentProperties:
    'Payments on disposal of investment properties',

  netCashFromFinancingActivities: 'Net cash from financing activities',
  proceedsFromIssuanceOfConvertibleBonds:
    'Proceeds from issuance of convertible bonds',
  paymentsForRedemptionOfConvertibleBonds:
    'Payments for redemption of convertible bonds',
  purchaseOfTreasuryShares: 'Purchase of treasury shares',
  proceedsFromSellingOfTreasuryShares:
    'Proceeds from selling of treasury shares',

  netIncreaseDecreaseInCashAndCashEquivalents:
    'Net Increase/(Decrease) in cash and cash equivalents',
  cashAndCashEquivalentsAtTheBeginningOfPeriod:
    'Cash and cash equivalents at the beginning of period',

  cashFlowStatementChart: {
    CFFromOperating: 'Net Cash from Operating',
    CFFromInvesting: 'Net Cash from Investing',
    CFFromFinancing: 'Net Cash from Financing',
    cashEquivalentsEnding: 'Cash & Equivalents Ending',
    chartTitle: 'CASH FLOW',

    CFFromOperatingTooltip: 'Net Cash from Operating: %{tooltipValue} Bn. VND',
    CFFromInvestingTooltip: 'Net Cash from Investing: %{tooltipValue} Bn. VND',
    CFFromFinancingTooltip: 'Net Cash from Financing: %{tooltipValue} Bn. VND',
    cashEquivalentsEndingTooltip:
      'Cash & Equivalents Ending: %{tooltipValue} Bn. VND',
  },

  interestAndSimilarIncome: 'Interest and Similar Income',
  interestAndSimilarExpenses: 'Interest and Similar Expenses',

  netInterestIncome: 'Net Interest Income',
  feesAndCommissionIncome: 'Fees and Commission income',
  feesAndCommissionExpenses: 'Fees and Commission expenses',
  netFeeAndCommissionIncome: 'Net Fee and Commission Income',
  netGainLossFromForeignCurrencyAndGoldDealings:
    'Net gain/(loss) from foreign currency and gold dealings',
  netGainLossFromTradingOfTradingSecurities:
    'Net gain/(loss) from trading of trading securities',
  netGainLossFromDisposalOfInvestmentSecurities:
    'Net gain/(loss) from disposal of investment securities',
  dividendsIncome: 'Dividends income',
  totalOperatingIncome: 'Total operating income',
  operatingProfitBeforeProvisionForCreditLosses:
    'Operating Profit Before Provision for Credit Losses',
  provisionForCreditLosses: 'Provision for credit losses',
  profitBeforeTax: 'Profit before tax',
  corporateIncomeTax: 'Corporate income tax',
  netProfitForTheYear: 'Net profit for the year',
  basicEarningsPerShareForProfitAttributableToTheEquityHolders: 'EPS (VND)',
  yAxisLeftChartTitle: 'Billion VND',
  yAxisRightChartTitle: 'Billion VND',

  // insurance income statement
  revenueFromInsurancePremium: 'Revenue from insurance premium',
  grossWrittenPremium: 'Gross written premium',
  reinsurancePremiumAssumned: 'Reinsurance premium assumned ',
  increaseDecreaseInUnearnedPremiumReserveForDirectInsuranceAndOutwardReinsurance:
    'Increase/(Decrease) in unearned premium reserve for direct insurance and outward reinsurance',
  deductions: 'Deductions',
  reinsurancePremiumCeded: 'Reinsurance premium ceded',
  increaseDecreaseInReinsurancePremiumCededReserve:
    'Increase/decrease in reinsurance premium ceded reserve',
  premiumDeductions: 'Premium deductions',
  premiumReturns: 'Premium returns',
  otherDeductions: 'Other deductions',
  netRevenueOfInsurancePremium: 'Net revenue of insurance premium',
  increaseInUnearnedPremiumReserveAndTechinicalReserve:
    'Increase in unearned premium reserve and techinical reserve',
  commissionIncomeFromOutwardReinsuranceAndOtherIncomeFromInsuranceActivities:
    'Commission income from  outward reinsurance and other income from insurance activities',
  commissionOnReinsuranceCeded: 'Commission on reinsurance ceded',
  otherIncome: 'Other income',
  incomeOnReinsuranceAssumed: 'Income on reinsurance assumed',
  incomeOnReinsuranceCeded: 'Income on reinsurance ceded',
  incomeFromOtherAcitvites: 'Income from other acitvites',
  netSalesFromInsuranceBusiness: 'Net sales from insurance business',
  claimExpense: 'Claim expense',
  totalClaimExpense: 'Total claim expense',
  claimAndMaturityPaymentExpenses: 'Claim and maturity payment expenses',
  claimExpensesForReinsuranceAssumed: 'Claim expenses for reinsurance assumed',
  claimExpenseDeductions: 'Deductions',
  recoveriesFormReinsuranceCeded: 'Recoveries form reinsurance ceded',
  subrogationRecoveries: 'Subrogation recoveries',
  salvages: 'Salvages',
  claimRecoveriesFromOutwardReinsurance:
    'Claim recoveries from outward reinsurance',
  claimExpensesOnRetainedRisks: 'Claim expenses on retained risks',
  increaseDecreaseInMathematicReserves:
    'Increase/(decrease) in mathematic reserves',
  increaseDecreaseInClaimReserve: 'Increase/(decrease) in claim reserve',
  increaseDecreaseInClaimReserveForDirectInsuranceAndInwardInsurance:
    'Increase/(decrease) in claim reserve for direct insurance and inward insurance',
  increaseDecreaseInClaimReserveForOutwardInsurance:
    'Increase/(decrease) in claim reserve for outward insurance',
  totalInsuranceClaimSettlementExpenses:
    'Total insurance claim settlement expenses',
  claimExpensesUsingCatastropheReserve:
    'Claim expenses using catastrophe reserve',
  provisionForCatastropheReserve: 'Provision for catastrophe reserve',
  otherInsuranceOperatingExpenses: 'Other insurance operating expenses',
  otherUnderwritingExpenses: 'Other underwriting expenses',
  commissions: 'Commissions',
  expenseOfRecourseAgainstTheThirdParty:
    'Expense of recourse against the third party',
  expenseOfHandlingFullyIndemnifiedGoods:
    'Expense of handling fully-indemnified goods',
  riskMinimizationExpenses: 'Risk minimization expenses',
  lossAdjustingFeeRiskAssessment: 'Loss adjusting fee, risk assessment',
  otherInsuranceSellingExpenses: 'Selling expenses',
  others: 'Others',
  otherReinsuranceAssumedExpenses: 'Other reinsurance assumed expenses',
  otherReinsuranceCededExpenses: 'Other reinsurance ceded expenses',
  otherDirectInsuranceOperatingExpenses:
    'Other direct insurance operating expenses',
  totalDirectInsuranceOperatingExpenses:
    'Total direct insurance operating expenses',
  grossInsuranceOperatingProfit: 'Gross insurance operating profit',
  netOperatingIncomeFromBankingActivities:
    'Net operating income from banking activities',
  incomeFromBankingActivities: 'Income from banking activities',
  expensesFromBankingActivities: 'Expenses from banking activities',
  profitFromRealEstateInvestmentActivities:
    'Profit from real estate investment activities',
  revenueFromRealEstate: 'Revenue from real estate',
  costOfRealEstate: 'Cost of real estate',
  profitFromFinancialActivities: 'Profit from financial activities',
  gainLossFromJointVentures: 'Gain/(loss) from joint ventures',
  netOperatingIncomeFromOtherActivities:
    'Net operating income from other activities',
  revenueFromOtherActivities: 'Revenue from other activities',
  expensesFromOtherActivities: 'Expenses from other activities',
  generalAndAdministrativeExpensesOfInsuranceOperation:
    'General and administrative expenses of insurance operation',
  generalAndAdministrativeExpensesOfBankingOperation:
    'General and administrative expenses of banking operation',
  generalAndAdministrativeExpensesOfOthersOperation:
    'General and administrative expenses of others operation',
  netOperatingProfitFromInsuranceOperation:
    'Net operating profit from insurance operation',
  lossFromLifeInsurance: 'Loss from life insurance',
  netProfitFromNonLifeInsurance: 'Net profit from non - life insurance ',
  netProfitFromBankOperation: 'Net profit from bank operation',
  netProfitFromOthersOperation: 'Net profit from others operation',
  netOtherIncomeOtherIncome: 'Other income',
  netOtherIncomeOtherExpenses: 'Other expenses',
  equalisationReserve: 'Equalisation reserve',
  businessIncomeTaxExpenses: 'Business income tax expenses',
  businessIncomeTaxCurrent: 'Business income tax - current',
  businessIncomeTaxDeferred: 'Business income tax - deferred',
  EPS_basis: 'EPS (VND)',

  BalanceSheetInsurance: {
    otherLiabilites: 'Other liabilities',
    longTermTradeReceivablesChild: 'Long-term trade receivables',
    otherLongtermReceivablesChild: 'Other long-term receivables',
    capitalAndReservesPreferedShares: 'Preferred Shares',
    inventoriesNet: 'Inventories (Net)',
    shorttermInvestmentsHeldtomaturityInvestment:
      'Held-to-maturity Investments',
    loansAndAdvancesToCustomersOne: 'LOANS AND ADVANCES TO CUSTOMERS',
    capitalAndReservesPreferredShares: 'Preferred Shares',
    totalAssets: 'TOTAL ASSETS',
    currentAssets: 'CURRENT ASSETS',
    currentAssetsLower: 'Current Asset',
    cashAndCashEquivalents: 'Cash and cash equivalents',
    cash: 'Cash  ',
    cashEquivalents: 'Cash equivalents',
    shorttermInvestments: 'Short-term investments',
    shorttermInvestmentsChild: 'Short-term investments',
    provisionForDiminution: 'Provision for diminution',
    heldtomaturityInvestment: 'Held-to-maturity investment',
    accountsReceivables: 'Accounts receivables',
    tradeAccountsReceivables: 'Trade accounts receivables',
    receivableFromInsuranceContract: 'Receivable from insurance contract',
    otherReceivablesFromCustomers: 'Other receivables from customers',
    prepaymentsToSuppliers: 'Prepayments to suppliers',
    intercompanyReceivables: 'Intercompany receivables',
    constructionContractInProgressReceivables:
      'Construction contract in progress receivables',
    shorttermLoansReceivables: 'Short-term loans receivables',
    advancedPayment: 'Advanced payment',
    receivableFromTradingStocks: 'Receivable from trading stocks',
    otherReceivables: 'Other receivables',
    provisionForDoubfulDebts: 'Provision for doubful debts',
    invetoriesNet: 'Invetories (Net)',
    inventories: 'Inventories',
    provisionForDeclineInInventories: 'Provision for decline in inventories',
    otherCurrentAssets: 'Other current assets',
    otherCurrentAssetsChild: 'Other current assets',
    shorttermPrepayments: 'Short-term prepayments',
    undistributedCommisionExpenses: 'Undistributed commision expenses',
    otherShorttermPrepayments: 'Other short-term prepayments',
    shortageOfCurrentAssetsWaitingForSolution:
      'Shortage of current assets waiting for solution',
    vatToBeClaimed: 'VAT to be claimed',
    otherTaxesReceivable: 'Other taxes receivable',
    marginDeposits: 'Margin deposits',
    governmentBondsPurchasedForResale: 'Government bonds purchased for resale',
    reinsuranceAssets: 'Reinsurance assets',
    provisionForPremiumOutwardReinsurance:
      'Provision for Premium outward reinsurance',
    provisionForClaimFormOutwardReinsurance:
      'Provision for claim form outward reinsurance',
    loansAndAdvancesToCustomers: 'Loans and advances to customers',
    provisionForCreditLoss: 'Provision for credit loss',
    longtermAsstes: 'LONG-TERM ASSTES',
    longtermTradeReceivables: 'Long-term trade receivables',
    longTermTradeReceivables: 'Long term trade receivables',
    longtermPrepaymentsToSuppliers: 'Long-term prepayments to suppliers',
    paidinCapitalInWhollyownedSubsidiaries:
      'Paid-in capital in wholly-owned subsidiaries',
    longtermIntercompanyReceivables: 'Long-term intercompany receivables',
    longtermLoansReceivables: 'Long-term loans receivables',
    otherLongtermReceivables: 'Other long-term receivables',
    insuranceDeposits: 'Insurance deposits',
    provisionForDoubfulLongtermReceivables:
      'Provision for doubful long-term receivables',
    fixedAssets: 'Fixed assets',
    tangibleFixedAssets: 'Tangible fixed assets',
    tangibleFixedAssetsCost: 'Cost',
    tangibleFixedAssetsAccumulatedDepreciation: 'Accumulated depreciation',
    financeLeaseAssets: 'Finance lease assets',
    financeLeaseAssetsCost: 'Cost',
    financeLeaseAssetsAccumulatedDepreciation: 'Accumulated depreciation',
    intagibleFixedAssets: 'Intagible fixed assets',
    intagibleFixedAssetsCost: 'Cost',
    intagibleFixedAssetsAccumulatedDepreciation: 'Accumulated depreciation',
    constructionInProgressBefore: 'Construction in progress (before 2015)',
    investmentProperties: 'Investment properties',
    investmentPropertiesCost: 'Cost',
    investmentPropertiesAccumulatedDepreciation: 'Accumulated depreciation',
    longtermIncompleteAssets: 'Long-term incomplete assets',
    longtermCostOfWorkInProgress: 'Long-term cost of work in progress',
    constructionInProgress: 'Construction in progress  ',
    longtermInvestments: 'Long-term investments',
    investmentInSubsidiaries: 'Investment in subsidiaries',
    investementInAssociates: 'Investement in associates',
    otherLongtermInvestements: 'Other long-term investements',
    provisionForLongtermInvestments: 'Provision for long-term investments',
    goodWillBefore: 'Good will (before 2015)',
    otherLongtermAssets: 'Other long-term assets',
    otherLongtermAssetsChild: 'Other long-term assets',
    longtermPrepayments: 'Long-term prepayments  ',
    deferredIncomeTaxAssests: 'Deferred income tax assests',
    longtermDeposit: 'Long-term deposit',
    longtermEquimentMaterialAndSpare: 'Long-term equiment, material and spare',
    goodWill: 'Good will  ',
    liabilities: 'LIABILITIES',
    currentLiabilities: 'Current liabilities',
    shorttermLoans: 'Short-term loans',
    tradeAccountsPayable: 'Trade accounts payable',
    payablesFromInsuranceContract: 'Payables from insurance contract',
    payablesToSuppliers: 'Payables to suppliers',
    advancesFromCustomers: 'Advances from customers',
    taxesAndOtherPayableToStateBudget:
      'Taxes and other payable to State Budget',
    payableToEmployees: 'Payable to employees',
    accruedExpenses: 'Accrued expenses',
    intercompanyPayables: 'Intercompany payables',
    constructionContractInProgressPayables:
      'Construction contract in progress payables',
    shorttermUnrealizedRevenue: 'Short-term unrealized revenue',
    unearnedCommissionIncome: 'Unearned commission income',
    otherPayables: 'Other payables',
    provisionForShorttermLiabilities: 'Provision for short-term liabilities',
    bonusAndWelfareFunds: 'Bonus and welfare funds',
    priceStablizationFund: 'Price stablization fund',
    governmentBondsPurchasedForResales:
      'Government bonds purchased for resales',
    insuranceReserve: 'Insurance reserve',
    unearnedPremiumReserve: 'Unearned premium reserve',
    mathematicalReserve: 'Mathematical reserve',
    claimReserve: 'Claim reserve',
    catastropheReserve: 'Catastrophe reserve',
    dividendReserve: 'Dividend reserve',
    equalizationReserve: 'Equalization reserve',
    amountDueToCustomers: 'Amount due to customers',
    depositFormCommercialBanks: 'Deposit from Commercial Banks',
    depositFromCustomers: 'Deposit from customers',
    longtermLiabilites: 'Long-term liabilites',
    longtermTradePayables: 'Long-term trade payables',
    longtermAdvancesFromCustomers: 'Long-term advances from customers',
    longtermAccruedExpenses: 'Long-term accrued expenses',
    intracompanyPayablesForOperatingCapital:
      'Intra-company payables for operating capital',
    longtermIntercompanyPayables: 'Long-term intercompany payables',
    otherLongtermPayables: 'Other long-term payables',
    longtermLoans: 'Long-term loans',
    convertibleBonds: 'Convertible bonds',
    preferredShares: 'Preferred shares',
    paidinCapitalPreferredShares: 'Preferred shares',
    longtermDepositMortage: 'Long-term deposit, mortage',
    deferredIncomeTaxesLiabilities: 'Deferred income taxes liabilities',
    provisionForSeveranceAllowances: 'Provision for severance allowances',
    provisionForLongtermLiabilites: 'Provision for long-term liabilites',
    deferredRevenue: 'Deferred revenue',
    technologyscienceDevelopmentFund: 'Technology-science development fund',
    reservesBefore: 'Reserves (before 2014)',
    unearnedPremiumReserveBefore: 'Unearned premium reserve (before 2014)',
    technicalReserveBefore: 'Technical reserve (before 2014)',
    claimReserveBefore: 'Claim reserve (before 2014)',
    catastropheReserveBefore: 'Catastrophe reserve (before 2014)',
    dividendReseveBefore: 'Dividend reseve (before 2014)',
    equalizatinReserveBefore: 'Equalization Reserve (Before 2014)',
    ownersEquity: "OWNER'S EQUITY",
    capitalAndReserves: 'Capital and reserves',
    paidinCapital: 'Paid-in capital ',
    commonShares: 'Common shares',
    capitalSurplus: 'Capital surplus',
    ownersOtherCapital: "Owner's other capital",
    treasuryShares: 'Treasury Shares',
    differencesUponAssetsRevaluation: 'Differences upon assets revaluation',
    foreignExchangeDifferences: 'Foreign exchange differences',
    investmentAndDevelopmentFunds: 'Investment and development funds',
    financialReserveFunds: 'Financial reserve funds',
    statutoryReserve: 'Statutory reserve',
    otherFunds: 'Other funds',
    undistributedEarnings: 'Undistributed earnings',
    beginningAccumulatedUndistritbutedEarning:
      'Beginning accumulated undistritbuted earning ',
    currentPeriodUndistributedEarnings: 'Current period undistributed earnings',
    enterpriseArragementFund: 'Enterprise arragement fund',
    minorityInterest: 'Minority interest   ',
    budgetSourcesAndOtherFunds: 'Budget sources and other funds',
    budgetSourcesAndOtherFundsChild: 'Budget sources and other funds',
    bonusAndWelfareFundsBefore: 'Bonus and welfare funds (before 2010)',
    fundsUsedForFixedAssetAcquisitions:
      'Funds used for fixed asset acquisitions',
    minorityInterestBefore: 'MINORITY INTEREST (before 2015)',
    totalResources: 'TOTAL RESOURCES',
    shareholdersEquity: "Shareholder's equity",
    otherAssets: 'Other assets',
  },
  BalanceSheetCK: {
    totalAssets: 'TOTAL ASSETS',
    currentAssets: 'CURRENT ASSETS',
    shorttermFinancialAssets: 'Short-term financial assets',
    cashAndCashEquivalents: 'Cash and cash equivalents',
    cash: 'Cash  ',
    cashEquivalents: 'Cash equivalents',
    shorttermInvestments: 'Short-term investments',
    shorttermInvestmets: 'Short-term investmets',
    heldtomaturityInvestment: 'Held-to-maturity investment',
    loans: 'Loans',
    availableForSalesAssets: 'Available for sales assets',
    provisionForDiminution: 'Provision for diminution',
    accountsReceivables: 'Accounts receivables',
    receivablesFrom: 'Receivables (from 2016)',
    tradeAccountsReceivable: 'Trade accounts receivable',
    deductibleValueAddedTax: 'Deductible value added tax',
    receivablesFromServicesProvidedByTheSecurities:
      'Receivables from services provided by the securities',
    prepaymentsToSuppliers: 'Prepayments to suppliers',
    intercompanyReceivables: 'Intercompany receivables ',
    receivablesAriseFromTransactionErrors:
      'Receivables arise from transaction errors',
    receivableFromTradingStocks: 'Receivable from trading stocks',
    constructionContractInProgress: 'Construction contract in progress',
    shorttermLoansReceivables: 'Short-term loans receivables',
    otherReceivables: 'Other receivables',
    provisionForShorttermReceivables: 'Provision for short-term receivables',
    ProvisionForDoubtfulDebts: ' Provision for doubtful debts',
    ShortageOfCurrentAssetsWatitingForSolution:
      ' Shortage of current assets watiting for solution',
    inventoriesNet: 'Inventories (Net)',
    inventories: 'Inventories  ',
    provisionForDeclineInInventories: 'Provision for decline in inventories',
    otherCurrentAssets: 'Other current assets',
    advancePayment: 'Advance payment',
    toolsAndEquipments: 'Tools and equipments',
    shorttermPrepayments: 'Short-term prepayments',
    shorttermCollaterals: 'Short-term Collaterals',
    vatToBeClaimed: 'VAT to be claimed',
    otherTaxesReceivables: 'Other taxes receivables',
    governmentBondsPurchasedForResales:
      'Government bonds purchased for resales',
    otherCurrentAssets_38: 'Other current assets',
    provisionForOtherCurrentAssets: 'Provision for other current assets',
    longtermAssets: 'LONG-TERM ASSETS',
    longtermFinancialAssets: 'Long-term financial assets',
    longtermTradeReceivables: 'Long-term trade receivables',
    longtermTradeReceivables_43: 'Long-term trade receivables',
    longtermPrepaymentsToSuppliers: 'Long-term prepayments to suppliers',
    paidinCapitalInWhollyownedSubsidiaries:
      'Paid-in capital in wholly-owned subsidiaries',
    longtermIntercompanyReceivables: 'Long-term intercompany receivables',
    longtermLoansReceivables: 'Long-term loans receivables',
    otherLongtermReceivables: 'Other long-term receivables',
    provisionForDoubtfulLongtermReceivables:
      'Provision for doubtful long-term receivables',
    longtermInvestments: 'Long-term investments',
    investmentsInSubsidiaries: 'Investments in subsidiaries',
    investmentsInAssociates: 'Investments in associates ',
    longtermSecuritiesInvestment: 'Long-term securities investment',
    otherLongtermInvestment: 'Other long-term investment',
    provisionForLongtermInvestments: 'Provision for long-term investments',
    fixedAssets: 'Fixed assets',
    tangibleFixedAssets: 'Tangible fixed assets',
    cost: 'Cost',
    accumulatedDepreciation: 'Accumulated depreciation',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel:
      ' Revaluation of tangible fixed assets using fair value model',
    financeLeaseAssets: 'Finance lease assets',
    cost_62: 'Cost',
    accumulatedDepreciation_63: 'Accumulated depreciation',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel_64:
      'Revaluation of fixed assets in financial lease using fair value model',
    intangibleFixedAssets: 'Intangible fixed assets',
    cost_66: 'Cost',
    accumulatedDepreciation_67: 'Accumulated depreciation',
    RevaluationOfTangibleFixedAssetsUsingFairValueModel_68:
      'Revaluation of intangible fixed assets using fair value model',
    constructionInProgressBefore: 'Construction in progress (before 2015) ',
    investmentProperties: 'Investment properties',
    cost_71: 'Cost',
    accumulatedDepreciation_72: 'Accumulated depreciation',
    revaluationOfInvestmentPropertyUsingFairValueModel:
      'Revaluation of investment property using fair value model',
    longtermIncompleteAssets: 'Long-term incomplete assets',
    longtermCostOfWorkInProgress: 'Long-term cost of work in progress',
    constructinInProgress: 'Construction in Progress',
    otherLongtermAssets: 'Other long-term assets',
    longtermCollaterals: 'Long-term collaterals',
    longtermPrepayments: 'Long-term prepayments',
    deferredIncomeTaxAssets: 'Deferred income tax assets',
    longtermEquipmentMaterialAndSpareParts:
      'Long-term equipment, material and spare parts',
    paymentsToSettlementAssistanceFund:
      'Payments to Settlement Assistance Fund',
    otherLongtermAssets_83: 'Other long-term assets',
    goodwill: 'Goodwill',
    provisionForLongTermAssets: 'Provision for long term assets',
    liabilities: 'LIABILITIES',
    currentLiabilities: 'Current liabilities',
    shorttermLoans: 'Short-term loans',
    shorttermLoans_89: 'Short-term loans',
    shorttermFinanceLease: 'Short-term finance lease',
    shorttermFinancialAssets_91: 'Short-term financial assets',
    shorttermConvertibleBonds: 'Short-term convertible bonds',
    shorttermBondsIssued: 'Short-term bonds issued',
    loansFromPayableAssistanceFund: 'Loans from payable assistance fund',
    payablesToSecuritiesTrading: 'Payables to securities trading',
    payableAriseFromTransactionErrors: 'Payable arise from transaction errors',
    tradeAccountsPayable: 'Trade accounts payable',
    advancesFromCustomers: 'Advances from customers',
    taxesAndOtherPayableToStateBudget:
      'Taxes and other payable to State Budget',
    payableToEmployees: 'Payable to employees',
    employeesWelfarePayableToAuthorities:
      "Employees' welfare payable to authorities",
    accruedExpenses: 'Accrued expenses',
    intercompanyPayables: 'Intercompany payables',
    shorttermUnrealizedRevenue: 'Short-term unrealized revenue',
    shorttermCollateralsReceivables: 'Short-term collaterals receivables',
    constructionContractInProgress_106: 'Construction contract in progress',
    dividendPrincipalAndInterestsPayables:
      'Dividend, principal and interests payables',
    payablesToSecuritiesIssues: 'Payables to securities issues',
    otherPayables: 'Other payables',
    provisionForShorttermLiabilities: 'Provision for short-term liabilities',
    bonusAndWelfareFunds: 'Bonus and welfare funds',
    priceStabilizationFund: 'Price stabilization fund',
    governmentBondsPurchasedForResale: 'Government bonds purchased for resale',
    longtermLiabilities: 'Long-term liabilities',
    LongtermLoans: ' Long-term loans',
    LongtermLoans_116: ' Long-term loans',
    LongtermFinanceLease: ' Long-term finance lease',
    longtermFinancialAssetsLoans: 'Long-term financial assets loans',
    convertibleBonds: 'Convertible bonds',
    longtermBonds: 'Long-term bonds',
    longtermTradePayables: 'Long-term trade payables',
    longtermAdvancesFromCustomers: 'Long-term advances from customers',
    longtermAccruedExpenses: 'Long-term accrued expenses',
    longtermIntercompanyPayables: 'Long-term intercompany payables',
    intracompanyPayablesForOperatingCapitalReceived:
      'Intra-company payables for operating capital received',
    deferredRevenue: 'Deferred revenue',
    longtermCollateralsReceived: 'Long-term collaterals received',
    otherLongtermPayables: 'Other long-term payables',
    preferredShares: 'Preferred shares',
    provisionForSeveranceAllowances: 'Provision for severance allowances',
    provisionForLongtermLiabilities: 'Provision for long-term liabilities',
    provisionForCompensationOfInvestors:
      'Provision for compensation of investors',
    DeferredIncomeTaxLiabilities: ' Deferred income tax liabilities',
    technologyscienceDevelopmentFund: 'Technology-science development fund',
    ownersEquity: "OWNER'S EQUITY",
    capitalAndReserves: 'Capital and reserves',
    sharholdersEquity: "Sharholders' equity",
    paidinCapital: 'Paid-in capital  ',
    capitalSurplus: 'Capital surplus',
    conversionOptionsOnConvertibleBonds:
      'Conversion options on convertible bonds',
    ownersOtherCapital: "Owner's other capital",
    treasuryShares: 'Treasury shares',
    differencesUponAssetRevaluation: 'Differences upon asset revaluation',
    foreignExchangeDifferences: 'Foreign exchange differences',
    charterReserve: 'Charter reserve',
    investmentAndDevelopment: 'Investment and development',
    financialReserveFunds: 'Financial reserve funds',
    otherFunds: 'Other funds',
    undistributedEarnings: 'Undistributed earnings',
    realizedGain: 'Realized gain',
    unrealizedGain: 'Unrealized gain',
    minorityInterest: 'Minority interest',
    budgetSourcesAndOtherFunds: 'Budget sources and other funds',
    bonusAndWelfareFundsBefore: 'Bonus and welfare funds (before 2010)',
    budgetSourcesAndOtherFunds_155: 'Budget sources and other funds',
    fundsUsedForFixedAssetAcquisitions:
      'Funds used for fixed asset acquisitions',
    minorityInterestBefore: 'MINORITY INTEREST (before 2015)',
    totalResources: 'TOTAL RESOURCES',
    distributedProfitToInvestor: 'DISTRIBUTED PROFIT TO INVESTOR',
    distributedProfitToInvestorDuringTheYear:
      'Distributed profit to investor during the year ',
  },

  //income statement ck
  incomeStatementCK: {
    sales: 'Sales',
    incomeFromFinancialAssetsRegconizedThroughProfitlossFvtpl:
      'Income from financial assets regconized through profit/loss (FVTPL)',
    incomeFromSellingFinancialAssets: 'Income from selling financial assets',
    fvtplRevaluationGain: 'FVTPL revaluation gain',
    dividendInterestFromFvtplFinancialAssets:
      'Dividend, interest from FVTPL financial assets',
    incomeFromHeldToMaturityInvestmentHtm:
      'Income from held to maturity investment (HTM)',
    incomeFromLoansAndReceivables: 'Income from loans and receivables',
    incomeFromAvailableForSalesAssetsAfs:
      'Income from available for sales assets (AFS)',
    incomeFromDerivatives: 'Income from derivatives',
    revenueInBrokerageServices: 'Revenue in brokerage services',
    revenueInUnderwritingServices: 'Revenue in underwriting services',
    revenueInIssuanceAgencyServices: 'Revenue in issuance agency services',
    revenueInAdvisoryServices: 'Revenue in advisory services',
    revenueInAuctionTrustServices: 'Revenue in auction trust services',
    revenueInSecuritiesCustodyService: 'Revenue in securities custody service',
    revenueInSecuritiesInvestmentAndOtherInvestmentActivitives:
      'Revenue in securities investment and other investment activitives',
    retalIncomeFromInvestmentProperty: 'Retal income from investment property',
    revenueIncomeFromAdvisoryServices: 'Revenue income from advisory services',
    OtherRevenues: ' Other revenues',
    salesDeductions: 'Sales deductions',
    netSales: 'Net sales',
    costOfSales: 'Cost of sales',
    lossFromFinancialAssetsRecognizedThroughProfitlossFvtpl:
      'Loss from financial assets recognized through profit/loss (FVTPL)',
    lossFromSellingFinancialAssetsFvtpl:
      'Loss from selling financial assets FVTPL',
    fvtplFinancialAssetsRevaluationLoss:
      'FVTPL financial assets revaluation loss',
    fvtplFinancialAssetsPurchaseTransactionCosts:
      'FVTPL financial assets purchase transaction costs',
    lossFromHeldToMaturityInvestment: 'Loss from held to maturity investment',
    interestCostLossFromLoansAndReceivables:
      'Interest cost, loss from loans and receivables',
    lossFromAvailableForSalesAssetsAfs:
      'Loss from available for sales assets (AFS)',
    provisionForLossesFromMortgageAssetsUncollectibleReceivablesAndBorrowingExpenses:
      'Provision for losses from mortgage assets, uncollectible receivables, and borrowing expenses',
    lossFromDerivatives: 'Loss from derivatives',
    proprietaryTradingServicesExpenses: 'Proprietary trading services expenses',
    brokerageExpenses: 'Brokerage expenses',
    underwritingSecuritiesIssuanceExpenses:
      'Underwriting, securities issuance expenses',
    expensesForSecuritiesAdvisory: 'Expenses for securities advisory',
    biddingAgentServiceExpensee: 'Bidding agent service expensee',
    investorsSecuritiesDepositoryExpenses:
      "Investors' securities depository expenses",
    expensesForFinancialAdvisoryActivities:
      'Expenses for financial advisory activities',
    otherExpenses: 'Other expenses',
    grossProfit: 'Gross Profit',
    revenueFromFinancialActivities: 'Revenue from financial activities',
    realizedAndUnrealizedForeignExchangeGain:
      'Realized and unrealized foreign exchange gain',
    incomeFromNonFixedAccruedDividendAndInterest:
      'Income from non fixed accrued dividend and interest',
    gainFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
      'Gain from disposals or sales of investment in subsidiaries, associates and joint ventures',
    otherRevenueFromInvestments: 'Other revenue from investments',
    financialExpenses: 'Financial expenses',
    realizedAndUnrealizedForeignExchangeLoss:
      'Realized and unrealized foreign exchange loss',
    interestExpenses: 'Interest expenses',
    lossFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Loss from disposals or sales of investments in subsidiaries, associates and joint ventures',
    provisionForLossesOnLongtermFinancialInvestement:
      'Provision for losses on long-term financial investement',
    otherInvestmentExpenses: 'Other investment expenses',
    gainlossFromJoinVentures: 'Gain/loss from join ventures',
    sellingCosts: 'Selling costs',
    generalAndAdminExpenses: 'General and admin expenses',
    operatingProfitloss: 'Operating profit/loss',
    netOtherIncomeexpenses: 'Net other income/expenses',
    otherIncome: 'Other income',
    otherExpenses_57: 'Other expenses',
    incomeFromInvestmentInOtherEntitiesBefore:
      'Income from investment in other entities (before 2015)',
    netAccountingProfitlossBeforeTax: 'Net accounting profit/loss before tax',
    realizedGain: 'Realized gain',
    unrealizedGain: 'Unrealized gain',
    businessIncomeTaxExpenses: 'Business income tax expenses',
    businessIncomeTaxCurrent: 'Business income tax - current',
    businessIncomeTaxdeferred: 'Business income tax-deferred',
    netProfitlossAfterTax: 'Net profit/loss after tax',
    attributableToParentCompany: 'Attributable to parent company',
    profitAfterTaxDeductedOfFunds: 'Profit after tax deducted of Funds',
    minorityInterests: 'Minority interests',
    otherComprehensiveGainLossAfterTax:
      'Other comprehensive gain (loss) after tax',
    gainlossFromRevaluationOfHeldMaturityInvestments:
      'Gain/loss from revaluation of held maturity investments',
    gainlossFromRevaluationOfAvailableForSalesFinancialAssets:
      'Gain/loss from revaluation of available for sales financial assets',
    gainlossDistributedFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Gain/loss distributed from investments in subsidiaries, associates and joint ventures',
    gainlossFromRevaluationOfDerivatives:
      'Gain/loss from revaluation of derivatives',
    gainlossFromForeignExchangeDifferenceOfOverseaOperations:
      'Gain/loss from foreign exchange difference of oversea operations',
    predistributedGainlossFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Pre-distributed gain/loss from investments in subsidiaries, associates and joint ventures',
    gainlossFromRevaluationOfDerivatives_76:
      'Gain/loss from revaluation of derivatives',
    gainlossFromRevaluationOfFixedAssetsUsingFairValueModel:
      'Gain/loss from revaluation of fixed assets using fair value model',
    comprehensiveIncomeDistributedToShareholders:
      'Comprehensive income distributed to shareholders',
    comprehensiveIncomeDistributedToUncontrolledShareholders:
      'Comprehensive income distributed to uncontrolled shareholders',
    netIncomeToCommonShare: 'Net income to common share',
    epsBasic: 'EPS basic (VND)',
    epsDiluted: 'EPS diluted (VND)',
  },
  //CF BH
  cashFlowStatementInsurance: {
    netCashInflowsoutflowsFromOperatingActivities:
      'Net cash inflows/(outflows) from operating activities',
    operatingProfitlossBeforeChangesInWc:
      'Operating profit/loss before changes in WC',
    netProfitlossBeforeTax: 'Net profit/(loss) before tax',
    depreciationAndAmortisation: 'Depreciation and amortisation',
    amortisationOfGoodwill: 'Amortisation of goodwill',
    provisions: 'Provisions',
    unrealisedForeignExchange: 'Unrealised foreign exchange',
    profitlossFromInvesting: 'Profit/loss from investing',
    interestExpense: 'Interest expense',
    interestIncomeAndDividend: 'Interest income and dividend',
    otherAdjustments: 'Other adjustments',
    increasedecreaseInReceivables: 'Increase/(decrease) in receivables',
    grossWrittenPremiumReceivables: 'Gross written premium receivables ',
    reinsuranceAssumedReceivables: 'Reinsurance assumed receivables',
    reinsuranceCededReceivables: 'Reinsurance ceded receivables',
    otherReceivablesFromInsuranceActivities:
      'Other receivables from insurance activities',
    intercompanyReceivablespayables: 'Inter-company receivables/payables',
    increasedecreaseInInventories: 'Increase/(decrease) in inventories',
    increasedecreaseInPayablesNotIncludingInterestPaidAndTaxExpensePaid:
      'Increase/(decrease) in payables (not including interest paid and tax expense paid)',
    grossWrittenPremiumPayables: 'Gross written premium payables',
    reinsuranceAssumedPayables: 'Reinsurance assumed payables',
    reinsuranceCededPayables: 'Reinsurance ceded payables',
    otherPayablesFromInsuranceActivities:
      'Other payables from insurance activities',
    payablesToEmployees: 'Payables to employees',
    increasedecreaseInPrepaidExpenese:
      'Increase/(decrease) in prepaid expenese',
    increasedecreaseInTradingSecurities:
      'Increase/(decrease) in trading securities',
    interestPaid: 'Interest paid',
    businessIncomeTaxPaid: 'Business income tax paid',
    otherReceiptsFromOperatingActivities:
      'Other receipts from operating activities',
    otherPaymentsOnOperatingActivities:
      'Other payments on operating activities',
    netCashInflowsoutflowsFromInvestingActivities:
      'Net cash inflows/(outflows) from investing activities',
    purchasesOfFixedAssetsAndOtherLongtermAssets:
      'Purchases of fixed assets and other long-term assets',
    proceedsFromDisposalOfFixedAssets: 'Proceeds from disposal of fixed assets',
    loansGrantedPurchasesOfDebtInstrument:
      'Loans granted, purchases of debt instrument',
    collectionOfLoansProceedsFromSalesOfDebtsInstruments:
      'Collection of loans, proceeds from sales of debts instruments',
    investmentInOtherEntities: 'Investment in other entities',
    proceedsFromDivestmentInOtherEntities:
      'Proceeds from divestment in other entities',
    dividendsAndInteresteReceived: 'Dividends and intereste received',
    netCashInflowsoutflowsFromFinancingActivities:
      'Net cash inflows/(outflows) from financing activities',
    proceedsFromIssueOfShares: 'Proceeds from issue of shares',
    paymentsForShareReturensAndRepurchases:
      'Payments For Returns And Repurchases',
    proceedsFromLoans: 'Proceeds from loans',
    repaymentOfLoans: 'Repayment of loans',
    financeLeasePrincipalPayments: 'Finance lease principal payments',
    dividendPaid: 'Dividend paid',
    netIncreaseInCashAndCashEquivalents:
      'Net increase in cash and cash equivalents',
    cashAndCashEquivalentsAtTheBeginningOfThePeriod:
      'Cash and cash equivalents at the beginning of the period',
    effectOfForeignExchangeDifferences:
      'Effect of foreign exchange differences',
    cashAndCashEquivalentsAtTheEndOfThePeriod:
      'Cash and cash equivalents at the end of the period',
  },

  //CF CK
  cashFlowStatementCK: {
    netCashInflowsoutflowsFromOperatingActivies:
      'Net cash inflows/(outflows) from operating activies',
    operatingProfitlossBeforeChangesInWc:
      'Operating profit/(loss) before changes in WC',
    netProfitlossBeforeTax: 'Net profit/(loss) before tax',
    adjustment: 'Adjustment',
    depreciationAndAmortisation: 'Depreciation and amortisation',
    amortisationOfGoodwill: 'Amortisation of goodwill',
    provisions: 'Provisions',
    unrealisedForeignExchangeGainloss:
      'Unrealised foreign exchange gain/(loss)',
    accruedExpenses: 'Accrued expenses',
    profitlossFromInvestingActivities: 'Profit/loss from investing activities',
    interestExpense: 'Interest expense',
    interestIncomeAndDividend: 'Interest income and dividend',
    otherAdjustments: 'Other adjustments',
    increaseInNoncashExpense: 'Increase in non-cash expense',
    lossOnValuationOfFairValueThroughProfitlossFinancialAssets:
      'Loss on valuation of fair value through profit/loss financial assets',
    lossFromFinancialAssetsSales: 'Loss from financial assets sales',
    lossFromDerivatives: 'Loss from derivatives',
    lossOnValuationOfAvailableForSaleFinancialAssets:
      'Loss on valuation of available for sale financial assets',
    decreaseInTheValueOfAvailableSalesAssets:
      'Decrease in the value of available sales assets',
    lossOnValuationOfHeldToMarturityInvestments:
      'Loss on valuation of held to marturity investments',
    lossOnTheDecreaseInValueOfLoansGiven:
      'Loss on the decrease in value of loans given',
    lossRegconizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
      'Loss regconized when reclassification of AFS is made and fair value is used for revaluation',
    lossFromDerivatives_22: 'Loss from derivatives',
    lossFromSalesOfFixedAssets: 'Loss from sales of fixed assets',
    decreaseInValueOfFixedAssets: 'Decrease in value of fixed assets',
    provisionForDecreaseInValueOfLongtermFinancialInvestments:
      'Provision for decrease in value of long-term financial investments',
    lossFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
      'Loss from disposals or sales of investment in subsidiaries, associates and joint ventures',
    otherLoss: 'Other loss',
    decreaseInNoncashRevenue: 'Decrease in non-cash revenue',
    gainFromRevaluationOfFairValueThroughProfitAndLossFinancialAssets:
      'Gain from revaluation of fair value through profit and loss financial assets',
    gainFromRevaluationOfFairValueThroughProfitAndLossFinancialDebts:
      'Gain from revaluation of fair value through profit and loss financial debts',
    gainFromSalesOfAvailableForSaleAssets:
      'Gain from sales of available for sale assets',
    reversalOfLossFromAvailableForSaleAssets:
      'Reversal of loss from available for sale assets',
    gainRecognizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
      'Gain recognized when reclassification of AFS is made and fair value is used for revaluation',
    gainFromDerivatives: 'Gain from derivatives',
    gainFromTheDecreaseInValueOfLoansGiven:
      'Gain from the decrease in value of loans given',
    reversalOfProvision: 'Reversal of provision',
    gainFromSalesOfFixedAssetsAndProperties:
      'Gain from sales of fixed assets and properties',
    gainFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
      'Gain from disposals or sales of investments in subsidiaries, associates and joint ventures',
    otherGain: 'Other gain',
    changeInAssetsAndOperatingLiabilities:
      'Change in assets and operating liabilities',
    increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets:
      'Increase (decrease) in fair value through profit and loss financial assets',
    increaseDecreaseInHeldToMarturityInvestments:
      'Increase (decrease) in held to marturity investments',
    increaseDecreaseInLoansGiven: 'Increase (decrease) in loans given',
    increaseDecreaseInAvailableforsaleFinancialAssets:
      'Increase (decrease) in available-for-sale financial assets',
    increaseDecreaseInOtherAssets: 'Increase (decrease) in other assets',
    increaseDecreaseInReceivableFromSellingFinancialAssets:
      'Increase (decrease) in receivable from selling financial assets',
    increaseDecreaseInFinancialAssetLoansAndFinancialLease:
      'Increase (decrease) in financial asset loans and financial lease',
    increaseDecreaseInFinancialAssetLoans:
      'Increase (decrease) in financial asset loans',
    increaseDecreaseInCovertibleBondequityPortion:
      'Increase (decrease) in covertible bond-equity portion',
    increaseDecreaseInIssuedBond: 'Increase (decrease) in issued bond',
    increaseDecreaseInBorrowingFromSettlementAssistanceFund:
      'Increase (decrease) in borrowing from Settlement Assistance Fund',
    IncreaseDecreaseInReceivableFromSellingFvtplFinancialAssets:
      '(-) Increase, (+) decrease in receivable from selling FVTPL financial assets',
    IncreaseDecreaseInReceivableFromInterestsOfFinancialAssets:
      '(-) Increase, (+) decrease in receivable from interests of financial assets',
    IncreaseDecreaseInReceivableFromServicesRendered:
      '(-) Increase, (+) decrease in receivable from services rendered',
    IncreaseDecreaseInReceibleFromTransactionErrors:
      '(-) Increase, (+) decrease in receible from transaction errors',
    IncreaseDecreaseInOtherReceivables:
      '(-) Increase, (+) decrease in other receivables',
    IncreaseDecreaseInExpensePayableNotIncludingInterestExpense:
      '(-) Increase, (+) decrease in expense payable (not including interest expense)',
    IncreaseDecreaseInTradePayables:
      '(+) Increase, (-) decrease in trade payables',
    IncreaseDecreaseInPayablesToSecuritiesIssuers:
      '(+) Increase, (-) decrease in payables to securities issuers',
    IncreaseDecreaseInContributionToEmployeesWelfare:
      "(+) Increase, (-) decrease in contribution to employees' welfare",
    IncreaseDecreaseInTaxAndPayablesToAuthority:
      '(+) Increase, (-) decrease in tax and payables to authority',
    IncreaseDecreaseInPayablesToEmployees:
      '(+) Increase, (-) decrease in payables to employees',
    IncreaseDecreaseInPayableAriseFromFinancialAssetTransactionErrors:
      '(+) Increase, (-) decrease in payable arise from financial asset transaction errors',
    IncreaseDecreaseInOtherPayable:
      '(+) Increase, (-) decrease in other payable',
    IncreaseDecreaseInBusinessIncomeTaxPaid:
      '(+) Increase, (-) decrease in business income tax paid',
    increaseDecreaseInInventories: 'Increase (decrease) in inventories',
    increaseDecreaseInPrepaidExpenses:
      'Increase (decrease) in prepaid expenses',
    increaseDecreaseInTradingSecurities:
      'Increase (decrease) in trading securities',
    interestPaid: 'Interest paid',
    otherReceiptsFromOperatingActivities:
      'Other receipts from operating activities',
    otherPaymentsOnOperatingActivities:
      'Other payments on operating activities',
    netCashInflowsoutflowsFromInvestingActivies:
      'Net cash inflows/(outflows) from investing activies',
    purchasesOfFixedAssetsAndOtherLongtermAssets:
      'Purchases of fixed assets and other long-term assets',
    ProceedsFromDisposalOfFixedAssets:
      ' Proceeds from disposal of fixed assets',
    LoansGrantedPurchasesOfDebtInstruments:
      ' Loans granted, purchases of debt instruments',
    collectionOfLoansProceedsFromSalesOfDebtsInstrument:
      'Collection of loans, proceeds from sales of debts instrument',
    InvestmentsInOtherEntities: ' Investments in other entities',
    ProceedsFromInvestmentInOtherEntities:
      ' Proceeds from investment in other entities',
    dividendsAndInterestReceived: 'Dividends and interest received',
    netCashInflowsoutflowsFromFinancingActivities:
      'Net cash inflows/(outflows) from financing activities',
    proceedsFromIssueOfShares: 'Proceeds from issue of shares',
    payMentsFroShareReturnsAndRepurchases:
      'Payments for share returns and repurchase',
    proceedsFromLoans: 'Proceeds from loans',
    loansFromSettlementAssistanceFundReceived:
      'Loans from Settlement Assistance Fund received',
    otherLoansReceived: 'Other loans received',
    repaymentOfLoans: 'Repayment of loans',
    loansPrincipalRepaidToSettlementAssistanceFund:
      'Loans Principal repaid to Settlement Assistance Fund',
    financialAssetsLoansPrincipalRepaid:
      'Financial assets loans principal repaid',
    otherLoansPrincipalRepaid: 'Other loans principal repaid',
    financialLeasePricipalPayments: 'Financial lease pricipal payments',
    dividensPaid: 'Dividends Paid',
    netIncreaseInCashAndCashEquivalents:
      'Net increase in cash and cash equivalents',
    cashAndCashEquivalentsAtTheBeginningOfPeriod:
      'Cash and cash equivalents at the beginning of period',
    cashAndBankDepositAtTheBeginningOfThePeriod:
      'Cash and bank deposit at the beginning of the period',
    cashEquivalents: 'Cash Equivalents',
    effectOfForeignExchangeDifferences:
      'Effect of foreign exchange differences',
    cashAndCashEquivalentsAtTheEndOfPeriod:
      'Cash and cash equivalents at the end of period',
  },
  footerNote: 'Unit: Billion VND',
  noData: 'Data is still updating',
};
